module.exports = __webpack_public_path__ + "media/images/top/img_pickup_chibakara-2fd20dfe00fbb2ba32cfa597f587b655.webp";